<template>
  <Skeleton v-if="!ready" height="28px" width="28px" />
  <button
    v-else
    class="rail-btn-hover rail-btn-nowrap margin-left-xs"
    aria-label="open Registry drawer"
    aria-haspopup="dialog"
    @click="handleOpenRegistrySlideout"
  >
    <i class="icon-28x28 registry-box"></i>
    <span class="nav-aside-text grid-x heavy-sm margin-left-xxs">Registry</span>
  </button>
</template>

<script setup>
import { ref } from 'vue';
import Skeleton from '@nuxt-common/atomic-ui/app/components/skeleton/Skeleton';
import useRegistrySlideout from '~/composables/features/useRegistrySlideout';
import { fireLinkTag } from '#shared/features/analytics/tagManager';
import { onKsFlagsReady } from '~/events';

const ready = ref(false);
const { openRegistrySlideout } = useRegistrySlideout();

const handleOpenRegistrySlideout = () => {
  openRegistrySlideout();
  fireLinkTag({
    event_name: 'registry drawer open',
    link_name: 'registry drawer open',
  });
};

onKsFlagsReady(() => {
  ready.value = true;
});
</script>

<style lang="scss" brand="bcom" scoped>
:deep(.registry-box) {
  opacity: 0.42;
}

@media only screen and (max-width: 1200px) {
  :deep(.nav-aside-text) {
    display: none;
  }
}
</style>
